import { AlertTriangle, ArrowLeft, Info } from "lucide-react";
import Layout from "../../../components/layout";
import { useNavigate, useParams } from "react-router-dom";
import React from "react";
import { getOrgData } from "../../../hooks";
import LoadingScreen from "../../../components/loadingscreen";
import LayoutContext from "../../../components/LayoutContext";

export default function StripeReturnURL({
  status,
  ...props
}) {

  const { orgid } = useParams();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = React.useState(true);

  const { setPageTitle } = React.useContext(LayoutContext);

  // set page title for breadcrumbs
  setPageTitle("Stripe Connection Setup");

  // check to make sure orgid is valid
  React.useEffect(() => {
    if (!orgid) {
      navigate("/error/404");
      return;
    }

    // check to make sure org is valid 
    let orgResponse = getOrgData(orgid);

    orgResponse.then((orgData) => {
      if (!orgData || !orgData.organization) {
        navigate("/error/404");
        return;
      }

      // set the title of the page
      document.title = `Stripe Connection Setup | ${orgData.organization.name} Dashboard | Advent by Endevre`;

      setIsLoading(false);
    });
  }, [orgid, navigate]);
  
  return (
    <Layout>
      {isLoading ? (
        <LoadingScreen />
      ) : (
        <div className="flex flex-col w-full h-full justify-center items-center">
          <div className="flex flex-col gap-4 items-center justify-center my-32">
            {status === "success" ? (
              <>
                <Info className="w-24 h-24 text-slate-500" />
                <div className="flex flex-col items-center justify-center gap-2">
                  <p className="text-slate-500 max-w-sm w-full text-center">We're connecting to Stripe, please check current status in your organization dashboard.</p>
                  <p className="text-slate-500 max-w-sm w-full text-center">This may take up to an hour</p>
                </div>
                <a 
                  href={"/organization/" + orgid + "/settings"} 
                  className="text-slate-500 bg-slate-200 hover:bg-slate-300/80 px-4 py-1 rounded-lg transition-colors duration-100 ease-in-out flex flex-row items-center justify-center gap-2"
                >
                  <ArrowLeft className="w-5 h-5" />
                  <span>Return to Dashboard</span>
                </a>
              </>
            ) : (
              <>
                <AlertTriangle className="w-24 h-24 text-red-500" />
                <div className="flex flex-col items-center justify-center">
                  <p className="text-red-500">We are unable to complete the Stripe setup,</p>
                  <p className="text-red-500">please try again later.</p>
                </div>
                <a 
                  href={"/organization/" + orgid + "/settings"} 
                  className="text-red-500 bg-red-200 hover:bg-red-300/80 px-4 py-1 rounded-lg transition-colors duration-100 ease-in-out flex flex-row items-center justify-center gap-2"
                >
                  <ArrowLeft className="w-5 h-5" />
                  <span>Return to Dashboard</span>
                </a>
              </>
            )}
          </div>
        </div>
      )}
    </Layout>
  )
}